// extracted by mini-css-extract-plugin
module.exports = {"ForgotTitle":"_13VWh","ForgotPasswordForm":"_2GsqU","FormField":"vOQq4","submitButton":"_1Il8n","centered":"_3TpF7","alreadyLogin":"_2OlYt","SuccessTitle":"_3KWh2"};